/**
 * DevExtreme (esm/__internal/viz/core/themes/generic/darkviolet.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
const ACCENT_COLOR = "#9c63ff";
const BACKGROUND_COLOR = "#17171f";
const TITLE_COLOR = "#f5f6f7";
const SUBTITLE_COLOR = "#fff";
const TEXT_COLOR = "#b2b2b6";
const BORDER_COLOR = "#343840";
export default [{
    baseThemeName: "generic.dark",
    theme: {
        name: "generic.darkviolet",
        defaultPalette: "Dark Violet",
        backgroundColor: "#17171f",
        primaryTitleColor: "#f5f6f7",
        secondaryTitleColor: "#fff",
        gridColor: "#343840",
        axisColor: "#b2b2b6",
        export: {
            backgroundColor: "#17171f",
            font: {
                color: "#f5f6f7"
            },
            button: {
                default: {
                    color: "#f5f6f7",
                    borderColor: "#414152",
                    backgroundColor: "#17171f"
                },
                hover: {
                    color: "#f5f6f7",
                    borderColor: "#5c5c74",
                    backgroundColor: "#2d2d3c"
                },
                focus: {
                    color: "#f5f6f7",
                    borderColor: "#7c7c97",
                    backgroundColor: "#2d2d3c"
                },
                active: {
                    color: "#f5f6f7",
                    borderColor: "#7c7c97",
                    backgroundColor: "#3c3c51"
                }
            }
        },
        legend: {
            font: {
                color: "#b2b2b6"
            }
        },
        tooltip: {
            color: "#17171f",
            border: {
                color: "#414152"
            },
            font: {
                color: "#f5f6f7"
            }
        },
        "chart:common": {
            commonSeriesSettings: {
                label: {
                    border: {
                        color: "#343840"
                    }
                }
            }
        },
        "chart:common:annotation": {
            font: {
                color: "#f5f6f7"
            },
            border: {
                color: "#414152"
            },
            color: "#17171f"
        },
        chart: {
            commonPaneSettings: {
                border: {
                    color: "#343840"
                }
            },
            commonAxisSettings: {
                breakStyle: {
                    color: "#575e6b"
                }
            }
        },
        funnel: {
            item: {
                border: {
                    color: "#17171f"
                }
            }
        },
        sparkline: {
            pointColor: "#17171f",
            minColor: "#f0ad4e",
            maxColor: "#d9534f"
        },
        treeMap: {
            group: {
                color: "#343840",
                label: {
                    font: {
                        color: "#fff"
                    }
                }
            }
        },
        rangeSelector: {
            shutter: {
                color: "#17171f"
            },
            scale: {
                breakStyle: {
                    color: "#575e6b"
                },
                tick: {
                    opacity: .2
                }
            },
            selectedRangeColor: "#9c63ff",
            sliderMarker: {
                color: "#9c63ff",
                font: {
                    color: "#fff"
                }
            },
            sliderHandle: {
                color: "#9c63ff",
                opacity: .5
            }
        },
        bullet: {
            color: "#9c63ff"
        },
        gauge: {
            valueIndicators: {
                rangebar: {
                    color: "#9c63ff"
                },
                textcloud: {
                    color: "#9c63ff"
                }
            }
        },
        sankey: {
            link: {
                border: {
                    color: "#17171f"
                }
            },
            node: {
                border: {
                    color: "#17171f"
                }
            }
        }
    }
}, {
    baseThemeName: "generic.darkviolet",
    theme: {
        name: "generic.darkviolet.compact"
    }
}];
